export default __webpack_public_path__ + "static/media/bnb-chain.098184ac.svg";